import { Const, PERMS, TOOLS } from "const";
import classnames from "classnames";
import { Link } from "react-router-dom";
import HelpInfo from "components/HelpInfo";
import { Utils } from "helpers/utils";
import { Switch, FormControlLabel } from '@mui/material';
import TextBox from "./TextBox";
import Select, { components } from 'react-select';
import { useEffect, useState } from "react";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { APIClient } from "api/apiCore";
import * as url from "api/urls"
import { tb_PermConfig } from "types";
import BackHeaderIcon from "./BackHeaderIcon";
import { UserTypes } from "api/auth";


interface ContentHeadProps {
	title: string,
	helpInfo: string[]
}
const ContentHead = ({ title, helpInfo }: ContentHeadProps) => {
	const contentTitle = title;
	const isDark = Utils.IsDarkTheme();

	return (
		<div className="d-flex align-items-center " style={{ borderBottom: "dashed gray 1px" }}>
			{/* <div className="flex-shrink-0 d-block d-md-none me-2">
				<Link
					to="#"
					// onClick={onHeaderClick}
					className={classnames("user-chat-remove text-muted font-size-24 p-2", { "user-chat-remove-dark": isDark })}
				>
					<i className="bx bx-chevron-left align-middle"></i>
				</Link>
			</div> */}
			<BackHeaderIcon headerOf="setting"></BackHeaderIcon>
			<div className="flex-grow-1 overflow-hidden ">
				<div className="d-flex align-items-center">
					<div
						className={classnames("flex-shrink-0", "chat-user-img", "align-self-center", "me-0", "ms-0",)}
					>
						<i className="text-muted me-3 fas fa-lock fz-15"></i>
					</div>
					<div className="flex-grow-1 overflow-hidden">
						<h6 className="text-truncate mb-0 font-size-18">
							<Link to="#" className="user-profile-show text-reset" dangerouslySetInnerHTML={{ __html: contentTitle }}>
								{/* {contentTitle} */}
							</Link>
							<HelpInfo infos={helpInfo} />
						</h6>
					</div>
				</div>
			</div>
		</div>
	);
}

interface PermConfigProps {
	permName: PERMS;
	defaultAllow: boolean;
}
const PermConfig = ({ permName, defaultAllow }: PermConfigProps) => {
	const { dispatch, useAppSelector } = useRedux();
	const storeData = createSelector(
		(state: any) => state.Settings,
		(state: any) => state.Profile2,
		(st, p2) => ({
			activeTool: st.activeTool,
			isAdmin: p2.isAdmin,
			userType: p2.userType,
			isItSupport: p2.isItSupport,
		})
	);
	const { activeTool, isAdmin, userType, isItSupport } = useAppSelector(storeData);
	const allowEdit = isAdmin || (isItSupport === true && userType === UserTypes.Employee);

	const getTitle = () => {
		switch (permName) {
			case PERMS.VISIBLE_CHAT_ICON: return `สิทธิ์การมองเห็น customer chat icon <i class="bx bx-conversation"></i>`;
			case PERMS.VISIBLE_CHAT_ICON_SUPPLIER: return `สิทธิ์การมองเห็น supplier chat icon <i class="bx bx-conversation"></i>`;
		}
		return "ไม่รู้กำหนดสิทธิ์อะไร"
	}
	const getHelpInfo = () => {
		switch (permName) {
			case PERMS.VISIBLE_CHAT_ICON: return [
				"กำหนดสิทธิ์ ว่าพนักงาน ฝ่ายใด แผนกใด หรือบุคคลใด มีสิทธิ์ในการมองเห็นปุ่ม chat ซึ่งเป็นปุ่มสำหรับเข้าห้องแชทกับ Customer"
			];
			case PERMS.VISIBLE_CHAT_ICON_SUPPLIER: return [
				"กำหนดสิทธิ์ ว่าพนักงาน ฝ่ายใด แผนกใด หรือบุคคลใด มีสิทธิ์ในการมองเห็นปุ่ม chat ซึ่งเป็นปุ่มสำหรับเข้าห้องแชทกับ Supplier"
			];			
		}
		return [];
	}

	// interface DdlOption { type: string; value: string; label: string; }
	// interface DdlOption { divisionName: string | null, departmentName: string | null, positionName: string | null, userId: string | null, displayName2: string | null, value: string; label: string; }
	const [ddlDivison, setDdlDivison] = useState<any[] | null>(null);
	const [ddlDepartment, setDdlDepartment] = useState<any[] | null>(null);
	const [ddlPosition, setDdlPosition] = useState<any[] | null>(null);
	const [ddlUser, setDdlUser] = useState<any[] | null>(null);

	useEffect(() => {
		try {
			const reloadDdl = /*activeTool == TOOLS.PERM_VISIBLE_CHAT_ICON && */ddlDivison === null;
			if (reloadDdl) {
				const api = new APIClient();
				api.fnPostForm(url.LOAD_DDL_VALUE_FOR_PERM)
					.then(rs => {
						const distinctDiv = Array.from(
							new Map(
								rs
									.filter((item: any) => item.divisionName) // Step 1: filter out empty name1
									.map((item: any) => {
										const updated = { ...item, label: item.divisionName, value: item.divisionName };
										return [item.divisionName, updated];
									})
							).values() // Get only the unique values
						).sort((a: any, b: any) => a.divisionName.localeCompare(b.divisionName));

						const distinctDep = Array.from(
							new Map(
								rs
									.filter((item: any) => item.departmentName) // Step 1: filter out empty name1
									.map((item: any) => {
										const updated = { ...item, label: item.departmentName, value: item.departmentName };
										return [item.departmentName, updated];
									})
							).values() // Get only the unique values
						).sort((a: any, b: any) => a.departmentName.localeCompare(b.departmentName));

						const distinctPos = Array.from(
							new Map(
								rs
									.filter((item: any) => item.positionName) // Step 1: filter out empty name1
									.map((item: any) => {
										const updated = { ...item, label: item.positionName, value: item.positionName };
										return [item.positionName, updated];
									})
							).values() // Get only the unique values
						).sort((a: any, b: any) => a.positionName.localeCompare(b.positionName));

						const distinctEmp = (rs ?? []).sort((a: any, b: any) => a.displayName2.localeCompare(b.displayName2)).map((item: any) => ({ ...item, label: item.displayName2, value: item.userId }))
						setDdlDivison(distinctDiv);
						setDdlDepartment(distinctDep);
						setDdlPosition(distinctPos);
						setDdlUser(distinctEmp);
					})
					.catch(e2 => Utils.HandleException(e2, true));
			}
		} catch (e) {
			Utils.HandleException(e, true);
		}
	}, [activeTool]);

	const [permData, setPermData] = useState<tb_PermConfig[]>([]);

	const reloadData = () => {
		try {
			const api = new APIClient();
			api.fnPostForm(url.LOAD_PERM_CONFIG, { permName: permName.toString() })
				.then(rs => {
					if (rs.length <= 0) {
						rs.push({
							uid: Utils.GetUniqueId(),
							entryId: null,
							permName: null,
							allow: true,
							userId: null,
							division: null,
							department: null,
							position: null,
						});
					}
					rs.forEach((x: any) => x.uid = Utils.GetUniqueId())
					setPermData(rs)
				})
				.catch(e2 => Utils.HandleException(e2, true));

		} catch (e) {
			Utils.HandleException(e, true);
		}
	}

	useEffect(() => {
		reloadData();
	}, [activeTool, permName]);

	useEffect(() => {
		// console.log('permData:', permData);
	}, [permData]);

	useEffect(() => {
		// console.log('ddlDivison:', ddlDivison);
	}, [ddlDivison]);

	const getSelectValue = (val: string | null | undefined, options: any[] | null | undefined) => {
		if (!val) return null;
		const found = options?.find(t => t.value?.toString() === val.toString());
		if (found) return found;
		return { value: val, label: `[ไม่พบ] ${val}`, __notFound: true };
	};

	const getEmptyRow = () => {
		return {
			uid: Utils.GetUniqueId(),
			entryId: null,
			permName: null,
			allow: defaultAllow,
			userId: null,
			division: null,
			department: null,
			position: null,
		}
	}

	const onRowAdd = () => {
		try {
			setPermData(prev => [...prev, getEmptyRow()]);
			// setPermData(prev =>
			// 	[...prev, {
			// 		uid: Utils.GetUniqueId(),
			// 		entryId: null,
			// 		permName: null,
			// 		allow: defaultAllow,
			// 		userId: null,
			// 		division: null,
			// 		department: null,
			// 		position: null,
			// 	}]);
		} catch (e) {
			Utils.HandleException(e, true);
		}
	}

	const onRowDel = (uid: string | null) => {
		try {
			setPermData(prev => prev.filter(x => x.uid !== uid));
		} catch (e) {
			Utils.HandleException(e, true);
		}

	}

	const onCancelData = () => {
		reloadData();
	}

	const onSaveData = () => {
		try {
			const perm = [...permData];
			perm.forEach(e => e.permName = permName);
			const parm = {
				permName: permName.toString(),
				perms: perm
			}
			const api = new APIClient;
			api.fnPostBody(url.SAVE_PERM_CONFIG, parm)
				.then(rs => setPermData(rs.map((p: any) => ({ ...p, uid: Utils.GetUniqueId() }))))
				.catch(e2 => Utils.HandleException(e2, true));
		} catch (e) {
			Utils.HandleException(e, true);
		}
	}

	return (
		<div className="general-right-container">
			{/* <button onClick={fnTest}>test</button> */}
			{/* <div className="p-2"> */}
			<div className="mb-3 d-flex justify-content-between">
				<ContentHead title={getTitle()} helpInfo={getHelpInfo()} />
				{allowEdit && (
					<div>
						<button className="btn btn-sm btn-warning" onClick={onCancelData}>ยกเลิก</button>
						&nbsp;
						<button className="btn btn-sm btn-primary" onClick={onSaveData}>บันทึก</button>
					</div>
				)}
			</div>
			{/* <div className="dsp-container d-flex justify-content-between"> */}
			<div className="container-fluid">
				{permData.length <= 0 && allowEdit && (
					<div className="row pb-1">
						<div className="col d-flex " style={{ justifyContent: "flex-end" }}>
							<i className="fz-15 hand text-success fas fa-plus-circle" onClick={onRowAdd}></i>
						</div>
					</div>
				)}
				{permData.map((item: tb_PermConfig, index: number) => {
					const ddlDepartmentFilter = ddlDepartment?.filter(x => !item.division || item.division === x.divisionName);
					const ddlPositionFilter = ddlPosition?.filter(x => !item.department || item.department === x.departmentName);
					const ddlUserFilter = ddlUser?.filter(x =>
						(!item.division || item.division === x.divisionName) &&
						(!item.department || item.department === x.departmentName) &&
						(!item.position || item.position === x.positionName)
					);

					const baseTheme = Utils.GetThemeForReactSelect();
					const selectStyles = {
						...baseTheme,
						menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
						singleValue: (base: any, props: any) => ({
							...(baseTheme.singleValue ? (baseTheme.singleValue as any)(base, props) : base),
							...(props.data?.__notFound ? { color: '#dc3545' } : {}),
						}),
					};
					return (
						<div key={index} className="row pb-1">
							<div className="col-1">
								{/* {item.uid} */}
								<FormControlLabel control={
									<Switch checked={item.allow ?? false}
										//onChange={(e) => setEditingData(prev => ({ ...(prev || {}), tag: { ...(prev.tag || {}), enabled: e.target.checked } }))}
										onChange={(e) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, allow: e.target.checked }))}
									/>
								}
									label={item.allow ? "Yes" : "No"} />
							</div>
							<div className="col">
								<Select
									placeholder="หน่วยงาน"
									options={ddlDivison as any[]}
									styles={selectStyles}
									menuPortalTarget={document.body}
									menuPosition="fixed"
									menuPlacement="auto"
									onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, division: e?.value }))}
									value={getSelectValue(item.division, ddlDivison)}
									isClearable={true}
								></Select>
							</div>
							<div className="col">
								<Select
									placeholder="แผนก"
									options={ddlDepartmentFilter as any[]}
									styles={selectStyles}
									menuPortalTarget={document.body}
									menuPosition="fixed"
									menuPlacement="auto"
									onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, department: e?.value }))}
									value={getSelectValue(item.department, ddlDepartmentFilter)}
									isClearable={true}
								></Select>
							</div>
							<div className="col">
								<Select
									placeholder="ตำแหน่ง"
									options={ddlPositionFilter as any[]}
									styles={selectStyles}
									menuPortalTarget={document.body}
									menuPosition="fixed"
									menuPlacement="auto"
									onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, position: e?.value }))}
									value={getSelectValue(item.position, ddlPositionFilter)}
									isClearable={true}
								></Select>
							</div>
							<div className="col">
								<Select
									placeholder="พนักงาน"
									options={ddlUserFilter as any[]}
									styles={selectStyles}
									menuPortalTarget={document.body}
									menuPosition="fixed"
									menuPlacement="auto"
									onChange={(e: any) => { setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, userId: e?.value })); }}
									value={getSelectValue(item.userId?.toString(), ddlUserFilter)}
									isClearable={true}
								></Select>
							</div>
							{allowEdit && (
								<div className="col-1 d-flex align-items-center" style={{ gap: "10px" }}>
									<i className="fz-15 hand  text-danger fas fa-minus-circle" onClick={() => onRowDel(item.uid)}></i>
									<i className="fz-15 hand text-success fas fa-plus-circle" onClick={onRowAdd}></i>
								</div>
							)}
						</div>
					)
				}
				)}
			</div>
		</div>
	);
}

export default PermConfig;